
import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
import router from "@/router";

@Component({
  components: {}
})

export default class DebtorWarningBanner extends Vue {

  @Prop({type: Boolean, default: false}) showDebtorWarningBanner!: boolean

  transfer(): void {
    router.push("/billing")
  }
}
